module.exports = __webpack_public_path__ + "img/6 johnny-torres-circulo.02332d87.png";